import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useLayoutEffect, useMemo } from 'react';
import { DEFAULT_BRAND } from './brands';
import { createAppTheme } from './createAppTheme';
import { applyCssVars } from './cssVars';

/**
 * Provides the app's MUI theme and mirrors the design tokens onto CSS custom
 * properties so plain CSS files follow the same palette.
 *
 * The site ships a single palette — {@link DEFAULT_BRAND} in the mode named by
 * `DEFAULT_MODE` — and there is no runtime switcher.
 *
 * @param {{ children: React.ReactNode }} props The wrapped app tree.
 * @returns {JSX.Element} The themed provider.
 */
export function AppThemeProvider({ children }) {
  const theme = useMemo(() => createAppTheme(DEFAULT_BRAND), []);

  // Mirror tokens to CSS variables before paint so the first frame is themed.
  useLayoutEffect(() => {
    applyCssVars(DEFAULT_BRAND);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
